import { useContext } from "react";

import { KeycloakContext } from "./KeycloakContext";

export function useKeycloak() {
  const { keycloak } = useContext(KeycloakContext);
  return keycloak;
}
